<template>
  <button class="Vue-Toastification__close-button" aria-label="close">
    <div class="i-ph-x-bold" />
  </button>
</template>
